var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockIcon = function SvgLockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.958 5.647v2.824h7.084V5.647c0-1.95-1.585-3.53-3.542-3.53a3.535 3.535 0 0 0-3.542 3.53M2.833 8.471V5.647C2.833 2.527 5.37 0 8.5 0s5.667 2.528 5.667 5.647v2.824A2.83 2.83 0 0 1 17 11.294v9.883A2.83 2.83 0 0 1 14.167 24H2.833A2.83 2.83 0 0 1 0 21.177v-9.883a2.83 2.83 0 0 1 2.833-2.823m9.209 2.117H2.833a.71.71 0 0 0-.708.706v9.883a.71.71 0 0 0 .708.705h11.334a.71.71 0 0 0 .708-.706v-9.882a.71.71 0 0 0-.708-.706z"
  })));
};
export default SvgLockIcon;